import { NeedsWorkReason, NeedsWorkRemitResolution } from 'store/types'

// The reasons a charge can need work, in the order the team reads them.
// "Other" takes the biller's own words.
export const NEEDS_WORK_REASON_OPTIONS: { value: NeedsWorkReason; label: string }[] = [
  { value: 'PAID_BELOW_EXPECTED', label: 'Paid below expected' },
  { value: 'WRONG_NETWORK_RATE', label: 'Wrong network rate' },
  { value: 'CALL_PAYER', label: 'Call payer' },
  { value: 'WAITING_ON_PAYER', label: 'Waiting on payer' },
  { value: 'APPEAL', label: 'Appeal' },
  { value: 'COB_QUESTION', label: 'COB question' },
  { value: 'OTHER', label: 'Other' },
]

export const needsWorkReasonLabel = (reason: NeedsWorkReason): string =>
  NEEDS_WORK_REASON_OPTIONS.find((option) => option.value === reason)?.label ?? reason

export const REMIT_RESOLUTION_LABELS: Record<NeedsWorkRemitResolution, string> = {
  POSTED: 'Remit posted as received',
  POSTED_WITH_CORRECTIONS: 'Remit posted with corrections',
  DISMISSED: 'Remit dismissed',
}

const DAY_MS = 24 * 60 * 60 * 1000

// A calendar day in the viewer's own time zone, YYYY-MM-DD.
export const localDay = (date: Date = new Date()): string => {
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${date.getFullYear()}-${month}-${day}`
}

/** How long an item has been on the list, the way a biller says it. */
export const flaggedFor = (createdAt: string, now: Date = new Date()): string => {
  const days = Math.floor((now.getTime() - new Date(createdAt).getTime()) / DAY_MS)

  if (days <= 0) return 'today'
  if (days === 1) return '1 day'

  return `${days} days`
}

export type FollowUpState = 'OVERDUE' | 'TODAY' | 'UPCOMING'

/** Where an item's follow-up date stands against today. */
export const followUpState = (followUpDate?: string | null, today: string = localDay()): FollowUpState | null => {
  if (!followUpDate) return null

  const day = followUpDate.slice(0, 10)

  if (day < today) return 'OVERDUE'
  if (day === today) return 'TODAY'

  return 'UPCOMING'
}

export const FOLLOW_UP_COLORS: Record<FollowUpState, string> = {
  OVERDUE: '#dc3545',
  TODAY: '#d9822b',
  UPCOMING: 'inherit',
}
